import { loadScript } from '~/utils/loadScript';
import { useEnvProps } from '~/composables/useEnvProps';

/**
 * Loads the TrueFit script.
 *
 * @async
 * @function
 * @returns {Promise<boolean>} A promise that resolves to `true` when the script has loaded successfully, otherwise it rejects with an error.
 */
export const loadTrueFit = () => {
  const { trueFitBrand, tagMngrEnv } = useEnvProps();
  /**
   * @param {string} str
   * @returns {string}
   */
  const addDot = (str) => {
    if (str === 'dev' || str === 'staging') {
      return `.${str}`;
    }
    return str;
  };
  /**
   * @returns {string}
   */
  const getTrueFitEnv = () => {
    switch (tagMngrEnv) {
      case 'dev':
        return 'dev';
      case 'qa':
        return 'staging';
      default:
        return '';
    }
  };

  /**
   * Truefit script url (only used once)
   *
   * @example
   * MACYS - QA
   *
   *  trueFitBrand = 'mcy'
   *  tagMngrEnv = 'qa'
   *
   *   ---> 'https://mcy-cdn.staging.truefitcorp.com/fitrec/mcy/js/fitrec.js?'
   *
   * @example
   * MACYS - PROD
   *
   *  trueFitBrand = 'mcy'
   *  tagMngrEnv = 'prod'
   *
   *   ---> 'https://mcy-cdn.truefitcorp.com/fitrec/mcy/js/fitrec.js?'
   */
  const trueFitHost = `https://${trueFitBrand}-cdn${addDot(getTrueFitEnv())}.truefitcorp.com/fitrec/${trueFitBrand}/js/fitrec.js?`;

  return new Promise((resolve, reject) => {
    const debug = false;

    // @ts-ignore
    window.tfcapi =
      window.tfcapi ||
      function initTFCapi(...args) {
        // @ts-ignore
        window.tfcapi.q = window.tfcapi.q || [];
        // @ts-ignore
        window.tfcapi.q.push(args);
      };

    loadScript(trueFitHost, { debug })
      .then(() => {
        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default loadTrueFit;
